import { Clock as Clock_kojaro } from './Clock.kojaro';
import { Clock as Clock_phosphor } from './Clock.phosphor';
import { Clock as Clock_zoomg } from './Clock.zoomg';
import { Clock as Clock_zoomit } from './Clock.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Clock_kojaro;

    case 'zoomg':
      return Clock_zoomg;

    case 'phosphor':
      return Clock_phosphor;

    default:
      return Clock_zoomit;
  }
};

export const Clock = IconRenderer();
